import React from 'react';
import { Icon } from './Icon.js';
export const IconFilter4 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 9H19V11L14 15V20L10 21.5V15L5 11V9Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M14 2.5L16.5 5L19 2.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M10 4.5L7.5 2L5 4.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconFilter4.js.map